"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Types = require("../util/Types");
var _CheckBoxView = _interopRequireDefault(require("./components/CheckBoxView"));
var _DeleteCellView = _interopRequireDefault(require("./components/DeleteCellView"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ActionHeaderCell = function ActionHeaderCell(_ref) {
  var includeSelectedIds = _ref.includeSelectedIds,
    toggleSelectAll = _ref.toggleSelectAll,
    Ids = _ref.Ids,
    count = _ref.count,
    rows = _ref.rows,
    column = _ref.column;
  var cellType = column.cellType;
  if (_Types.cellTypes.CHECKBOX === cellType) {
    return /*#__PURE__*/_react.default.createElement(_CheckBoxView.default, {
      includeSelectedIds: includeSelectedIds,
      toggleSelectAll: toggleSelectAll,
      Ids: Ids
    });
  }
  if (_Types.cellTypes.DELETE === cellType) {
    return /*#__PURE__*/_react.default.createElement(_DeleteCellView.default, {
      rows: rows,
      count: count,
      column: column
    });
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
var _default = ActionHeaderCell;
exports.default = _default;